import TextButtonIcon from "@@/components/Button/TextButtonIcon";
import Icon, { IconTypes } from "@@/elements/Icons/Icon";
import SvgArrowRight from "@@/elements/Icons/icons/ArrowRight";
import Typography from "@@/elements/Typography";
import EpiProperty from "@@/integrations/optimizly/Property";
import { LinkData } from "@@/models/linkdata";
import cn from "classnames";
import OptimizelyBlock, { OptimizelyBlockProps } from "../../../integrations/optimizly/Block";
import styles from "./index.module.scss";

type Colors = "green" | "blue" | "beige" | "white";
type USPCardProperties = {
  icon: IconTypes
  heading?: string
  body?: string
  link?: LinkData
}; 
type USPCardOwnProps = {
  iconColor?: Colors;
  borderColor?: Colors;
  anchorId?: string;
};

export type USPCardProps = USPCardProperties & USPCardOwnProps;

export const USPCard = ({ icon, iconColor, heading, body, link, borderColor, anchorId }: USPCardProps) => {
  const classNames = cn(styles.outer_circle, {
    [styles[`outer_circle_${iconColor}`]]: iconColor,
  });
  return (
    <div id={anchorId}>
      <div className={classNames}>
        <EpiProperty<USPCardProperties> name="icon">
          <div className={cn(styles.inner_circle, {
            [styles[`inner_circle_${borderColor}`]]: !!borderColor })}>
            <div className={styles.usp_card__svg}>
              <Icon
                aria-hidden="true"
                name={icon} />
            </div>
          </div>
        </EpiProperty>
      </div>
      <div className={styles.container}>
        {heading && (
          <EpiProperty<USPCardProperties> name="heading">
            <Typography asElement="h3" variant="button">{heading}</Typography>
          </EpiProperty>
        )}
        {body && (
          <EpiProperty<USPCardProperties> name="body">
            <Typography variant="body">{body}</Typography>
          </EpiProperty>
        )}
        {link && link.text && (
          <EpiProperty<USPCardProperties> name="link">
            <TextButtonIcon
              textVariant="link"
              dense 
              direction="right"
              label={link.text}
              title={link.title}
              color="blue"
              link={link}
              target={link.target}
            >
              <SvgArrowRight/>
            </TextButtonIcon>
          </EpiProperty>
        )}
      </div>
    </div>
  );
};

export type ProvidedUSPCardProps =
    OptimizelyBlockProps<USPCardProperties> & USPCardProps;

const ProvidedUSPCard = ({
    blockId,
    inEditMode,
    properties,
    ...rest
}: ProvidedUSPCardProps) => {
    return (
        <OptimizelyBlock
            blockId={blockId}
            inEditMode={inEditMode}
            properties={properties}
        >
            {(optimizlyProperties) => (
                <USPCard
                    {...rest}
                    {...optimizlyProperties} />
            )}
        </OptimizelyBlock>
    );
};

export default ProvidedUSPCard;